import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
/*default路由*/
const default_layout = r => require.ensure([], () => r(require('./views/layout.vue')), 'home')
const default_home = r => require.ensure([], () => r(require('./views/home/index/index.vue')), 'home')
const default_register = r => require.ensure([], () => r(require('./views/home/register.vue')), 'home')
// // const default_registerStep1 = r => require.ensure([], () => r(require('./views/home/register/registerStep1.vue')), 'home')
const default_findPwd = r => require.ensure([], () => r(require('./views/home/findPwd.vue')), 'home')
const default_print = r => require.ensure([], () => r(require('./views/print/print.vue')), 'home')
const default_grade = r => require.ensure([], () => r(require('./views/grade/grade.vue')), 'home')
const default_moreAnnoucement = r => require.ensure([], () => r(require('./views/home/moreAnnoucement.vue')), 'home')
const default_closeTip = r => require.ensure([], () => r(require('./views/closeTip/closeTip.vue')), 'home')
const default_order_chooseBatch = r => require.ensure([], () => r(require('./views/order/chooseBatch.vue')), 'home')
const default_order = r => require.ensure([], () => r(require('./views/order/order.vue')), 'home')
const default_notFound = r => require.ensure([], () => r(require('./views/errors/404.vue')), 'home')
const default_printPage = r => require.ensure([], () => r(require('./views/print/printPage.vue')), 'home')
const asset_index = r => require.ensure([], () => r(require('./views/zicanpingushi/zicanindex.vue')), 'home')
const asset_textTip = r => require.ensure([], () => r(require('./views/zicanpingushi/textTip.vue')), 'home')
const asset_invoiceTip = r => require.ensure([], () => r(require('./views/zicanpingushi/invoiceTip.vue')), 'home')
const asset_download = r => require.ensure([], () => r(require('./views/zicanpingushi/download.vue')), 'home')

const default_myReservation = r => require.ensure([], () => r(require('./views/usercenter/myReservation.vue')), 'userCenter')
const default_userInform = r => require.ensure([], () => r(require('./views/usercenter/userInform.vue')), 'userCenter')
const default_safeProblem = r => require.ensure([], () => r(require('./views/usercenter/safeProblem.vue')), 'userCenter')
const default_usuQuse = r => require.ensure([], () => r(require('./views/usercenter/usuQuse.vue')), 'userCenter')
const default_myRegister = r => require.ensure([], () => r(require('./views/usercenter/myRegister.vue')), 'userCenter')
const default_myExcuse = r => require.ensure([], () => r(require('./views/usercenter/myExcuse.vue')), 'userCenter')
const default_myInvoice = r => require.ensure([], () => r(require('./views/usercenter/myInvoice.vue')), 'userCenter')
// /* 考试报名模块 */
const default_examReg_chooseBatch = r => require.ensure([], () => r(require('./views/examRegisteation/chooseBatch.vue')), 'examRegisteation');
// // const default_examReg_loading = r => require.ensure([], () => r(require('./views/examRegisteation/loading.vue')), 'examRegisteation')
const default_examReg_closeTip = r => require.ensure([], () => r(require('./views/examRegisteation/closeTip.vue')), 'examRegisteation');
const default_examReg_orderCloseTip = r => require.ensure([], () => r(require('./views/order/orderCloseTip.vue')), 'examRegisteation');
const default_examReg_examNotes = r => require.ensure([], () => r(require('./views/examRegisteation/examNotes.vue')), 'examRegisteation');
const default_examReg_baseCollection = r => require.ensure([], () => r(require('./views/examRegisteation/baseCollection.vue')), 'examRegisteation');
const default_examReg_imgCollection = r => require.ensure([], () => r(require('./views/examRegisteation/imgCollection.vue')), 'examRegisteation');
const default_examReg_fileCollection = r => require.ensure([], () => r(require('./views/examRegisteation/fileCollection.vue')), 'examRegisteation');
const default_examReg_chooseExamRegion = r => require.ensure([], () => r(require('./views/examRegisteation/chooseExamRegion.vue')), 'examRegisteation');
const default_examReg_chooseSubject = r => require.ensure([], () => r(require('./views/examRegisteation/chooseSubject.vue')), 'examRegisteation');
const default_examReg_chooseExamRegion2 = r => require.ensure([], () => r(require('./views/examRegisteation/chooseExamRegion2.vue')), 'examRegisteation');
const default_examReg_chooseSubject2 = r => require.ensure([], () => r(require('./views/examRegisteation/chooseSubject2.vue')), 'examRegisteation');
const default_examReg_confirmRegInfo = r => require.ensure([], () => r(require('./views/examRegisteation/confirmRegInfo.vue')), 'examRegisteation');
const default_examReg_submitRegInfo = r => require.ensure([], () => r(require('./views/examRegisteation/submitRegInfo.vue')), 'examRegisteation');
const default_examReg_payOrder = r => require.ensure([], () => r(require('./views/examRegisteation/payOrder.vue')), 'examRegisteation');
const default_examReg_payBack = r => require.ensure([], () => r(require('./views/examRegisteation/payBack.vue')), 'examRegisteation');
const default_examReg_payLoading = r => require.ensure([], () => r(require('./views/examRegisteation/openPayPage.vue')), 'examRegisteation');
const default_examReg_editSubject = r => require.ensure([], () => r(require('./views/examRegisteation/editSubject.vue')), 'examRegisteation');
const default_examReg_editRegion = r => require.ensure([], () => r(require('./views/examRegisteation/editExamRegion.vue')), 'examRegisteation');
// /* 免试申请模块 */
const default_excuseExam_chooseBatch = r => require.ensure([], () => r(require('./views/excuseExam/chooseBatch.vue')), 'excuseExam');
const default_excuseExam_closeTip = r => require.ensure([], () => r(require('./views/excuseExam/closeTip.vue')), 'excuseExam');
const default_excuseExam_examNotes = r => require.ensure([], () => r(require('./views/excuseExam/examNotes.vue')), 'excuseExam');
const default_excuseExam_baseCollection = r => require.ensure([], () => r(require('./views/excuseExam/baseCollection.vue')), 'excuseExam');
const default_excuseExam_imgCollection = r => require.ensure([], () => r(require('./views/excuseExam/imgCollection.vue')), 'excuseExam');
const default_excuseExam_fileCollection = r => require.ensure([], () => r(require('./views/excuseExam/fileCollection.vue')), 'excuseExam');
const default_excuseExam_confirmRegInfo = r => require.ensure([], () => r(require('./views/excuseExam/confirmExcuseInfo.vue')), 'examRegisteation');
const default_excuseExam_submitRegInfo = r => require.ensure([], () => r(require('./views/excuseExam/submitExcuseInfo.vue')), 'examRegisteation');
//贝壳预约跳转
const default_order_beikeReservation = r => require.ensure([], () => r(require('./views/order/beikeReservation.vue')), 'home');
//导游首页
const default_dyIndex = r => require.ensure([], () => r(require('./views/daoyou/index.vue')), 'm2_daoyou')
const default_noticePage = r => require.ensure([], () => r(require('./views/daoyou/noticePage.vue')), 'm2_daoyou')
const default_dynotice = r => require.ensure([], () => r(require('./views/daoyou/notice.vue')), 'm2_daoyou')
export default new Router({
    // const router = new Router({
    // mode: Hash,
    routes: [
        /*默认模板路由开始*/
        {

            name: 'layout',
            path: '',
            component: default_layout,
            meta: {
                requiresAuth: false,
                pageTitle: '模板页'
            },
            children: [
                {
                    name: 'main',
                    path: '/e/:projectCode/login',
                    component: default_home,
                    meta: {
                        requiresAuth: false,
                        pageTitle: '首页',
                    },
                    beforeEnter: (to, from, next) => {
                        from.meta.keepAlive = false;
                        to.meta.keepAlive = false;
                        next()
                    }
                },
                {
                    name: 'batch_main',
                    path: '/e/:projectCode/:batchCode/login',
                    component: default_home,
                    meta: {
                        requiresAuth: false,
                        pageTitle: '首页',
                    },
                    beforeEnter: (to, from, next) => {
                        from.meta.keepAlive = false;
                        to.meta.keepAlive = false;
                        next()
                    }
                },
                {
                    name: 'print',
                    path: '/default/print',
                    component: default_print,
                    meta: {
                        projectPage: true,
                        pageTitle: '打印准考证'
                    }
                }, 
                {
                    name: 'grade',
                    path: '/default/grade',
                    component: default_grade,
                    meta: {
                        projectPage: true,
                        pageTitle: '成绩查询'
                    }
                },

                //预约
                {
                    name: 'order.chooseBatch',
                    path: '/default/order/chooseBatch',
                    component: default_order_chooseBatch,
                    meta: {
                        projectPage: true,
                        pageTitle: '选择批次'
                    }
                },
                {
                    name: 'order',
                    path: '/default/order',
                    component: default_order,
                    meta: {
                        projectPage: true,
                        pageTitle: '预约考试'
                    }
                },
                //免试申请
                {
                    name: 'excuseExam.chooseBatch',
                    path: '/default/excuseExam/chooseBatch',
                    component: default_excuseExam_chooseBatch,
                    meta: {
                        projectPage: true,
                        pageTitle: '选择批次'
                    }
                },
                {
                    name: 'excuseExam.closeTip',
                    path: '/default/excuseExam/closeTip',
                    component: default_excuseExam_closeTip,
                    meta: {
                        projectPage: true,
                        pageTitle: '暂未开放'
                    }
                },
                {
                    name: 'excuseExam.examNotes',
                    path: '/default/excuseExam/examNotes',
                    component: default_excuseExam_examNotes,
                    meta: {
                        projectPage: true,
                        pageTitle: '免试承诺书'
                    }
                },
                {
                    name: 'excuseExam.baseCollection',
                    path: '/default/excuseExam/baseCollection',
                    component: default_excuseExam_baseCollection,
                    meta: {
                        projectPage: true,
                        pageTitle: '免试信息收集'
                    }
                },
                {
                    name: 'excuseExam.imgCollection',
                    path: '/default/excuseExam/imgCollection',
                    component: default_excuseExam_imgCollection,
                    meta: {
                        projectPage: true,
                        pageTitle: '免试图片收集'
                    }
                },
                {
                    name: 'excuseExam.fileCollection',
                    path: '/default/excuseExam/fileCollection',
                    component: default_excuseExam_fileCollection,
                    meta: {
                        projectPage: true,
                        pageTitle: '免试文件收集'
                    }
                },
                {
                    name: 'excuseExam.confirmRegInfo',
                    path: '/default/excuseExam/confirmRegInfo',
                    component: default_excuseExam_confirmRegInfo,
                    meta: {
                        projectPage: true,
                        pageTitle: '免试信息确认'
                    }
                },
                {
                    name: 'excuseExam.submitRegInfo',
                    path: '/default/excuseExam/submitRegInfo',
                    component: default_excuseExam_submitRegInfo,
                    meta: {
                        projectPage: true,
                        pageTitle: '免试信息提交'
                    }
                },
                //报考
                {
                    name: 'default.examReg.chooseBatch',
                    path: '/default/examReg/chooseBatch',
                    component: default_examReg_chooseBatch,
                    meta: {
                        projectPage: true,
                        pageTitle: '选择批次'
                    }
                },
                // {
                //     name: 'default.examReg.loading',
                //     path: '/default/examReg/loading',
                //     component: default_examReg_loading,
                //     meta: {
                //         pageTitle: '加载中...'
                //     }
                // },
                {
                    name: 'default.examReg.closeTip',
                    path: '/default/examReg/closeTip',
                    component: default_examReg_closeTip,
                    meta: {
                        projectPage: true,
                        pageTitle: '考试报名'
                    }
                },
                {
                    name: 'default.examReg.orderCloseTip',
                    path: '/default/examReg/orderCloseTip',
                    component: default_examReg_orderCloseTip,
                    meta: {
                        projectPage: true,
                        pageTitle: '考试预约'
                    }
                },
                {
                    name: 'default.closeTip',
                    path: '/default/closeTip/:type/:time',
                    component: default_closeTip,
                    meta: {
                        projectPage: true,
                        pageTitle: '未开放'
                    }
                },
                {
                    name: 'default.examReg.examNotes',
                    path: '/default/examReg/examNotes',
                    component: default_examReg_examNotes,
                    meta: {
                        projectPage: true,
                        pageTitle: '报名须知'
                    }
                },
                {
                    name: 'default.examReg.baseCollection',
                    path: '/default/examReg/baseCollection',
                    component: default_examReg_baseCollection,
                    meta: {
                        projectPage: true,
                        pageTitle: '基本信息采集'
                    }
                },
                {
                    name: 'default.examReg.imgCollection',
                    path: '/default/examReg/imgCollection',
                    component: default_examReg_imgCollection,
                    meta: {
                        projectPage: true,
                        pageTitle: '图片信息采集'
                    }
                },
                {
                    name: 'default.examReg.fileCollection',
                    path: '/default/examReg/fileCollection',
                    component: default_examReg_fileCollection,
                    meta: {
                        projectPage: true,
                        pageTitle: '附件信息采集'
                    }
                },
                {
                    name: 'default.examReg.chooseExamRegion',
                    path: '/default/examReg/chooseExamRegion',
                    component: default_examReg_chooseExamRegion,
                    meta: {
                        projectPage: true,
                        pageTitle: '选择考区'
                    }
                },
                {
                    name: 'default.examReg.chooseExamRegion2',
                    path: '/default/examReg/chooseExamRegion2',
                    component: default_examReg_chooseExamRegion2,
                    meta: {
                        projectPage: true,
                        pageTitle: '选择考区'
                    }
                },
                {
                    name: 'default.examReg.chooseSubject',
                    path: '/default/examReg/chooseSubject',
                    component: default_examReg_chooseSubject,
                    meta: {
                        projectPage: true,
                        pageTitle: '选择科目'
                    }
                },
                {
                    name: 'default.examReg.chooseSubject2',
                    path: '/default/examReg/chooseSubject2',
                    component: default_examReg_chooseSubject2,
                    meta: {
                        projectPage: true,
                        pageTitle: '选择科目'
                    }
                },
                {
                    name: 'default.examReg.editRegion',
                    path: '/default/examReg/editRegion',
                    component: default_examReg_editRegion,
                    meta: {
                        projectPage: true,
                        pageTitle: '修改考区'
                    }
                },
                {
                    name: 'default.examReg.editSubject',
                    path: '/default/examReg/editSubject',
                    component: default_examReg_editSubject,
                    meta: {
                        projectPage: true,
                        pageTitle: '修改科目'
                    }
                },
                {
                    name: 'default.examReg.confirmRegInfo',
                    path: '/default/examReg/confirmRegInfo',
                    component: default_examReg_confirmRegInfo,
                    meta: {
                        projectPage: true,
                        pageTitle: '报考信息'
                    }
                },
                {
                    name: 'default.examReg.submitRegInfo',
                    path: '/default/examReg/submitRegInfo',
                    component: default_examReg_submitRegInfo,
                    meta: {
                        projectPage: true,
                        pageTitle: '报考信息'
                    }
                },
                {
                    name: 'default.examReg.payOrder',
                    path: '/default/examReg/payOrder',
                    component: default_examReg_payOrder,
                    meta: {
                        projectPage: true,
                        pageTitle: '支付订单'
                    }
                },
                {
                    name: 'default_myReservation',
                    path: '/default/myReservation',
                    component: default_myReservation,
                    meta: {
                        projectPage: true,
                        pageTitle: '我的预约'
                    },
                },
                {
                    name: 'default_myRegister',
                    path: '/default/myRegister',
                    component: default_myRegister,
                    meta: {
                        projectPage: true,
                        pageTitle: '我的报考'
                    },
                },
                {
                    name: 'default_myExcuse',
                    path: '/default/myExcuse',
                    component: default_myExcuse,
                    meta: {
                        projectPage: true,
                        pageTitle: '我的免试'
                    },
                },
                {
                    name: 'default_myInvoice',
                    path: '/default/myInvoice',
                    component: default_myInvoice,
                    meta: {
                        projectPage: true,
                        pageTitle: '我的发票'
                    },
                },
                {
                    name: 'default_userInform',
                    path: '/default/userInform',
                    component: default_userInform,
                    meta: {
                        pageTitle: '个人信息'
                    },
                },
                {
                    name: 'default_safeProblem',
                    path: '/default/safeProblem',
                    component: default_safeProblem,
                    meta: {
                        pageTitle: '账户安全'
                    },
                },
                {
                    name: 'default_usuQuse',
                    path: '/default/usuQuse',
                    component: default_usuQuse,
                    meta: {
                        pageTitle: '常见问题'
                    },
                },
            ]
        },
        {
            name: 'default_examReg_payLoading',
            path: '/default/payLoading',
            component: default_examReg_payLoading,
            meta: {
                pageTitle: '支付跳转'
            }
        },
        {
            name: 'asset_index',
            path: '/asset/index',
            component: asset_index,
            meta: {
                requiresAuth: false,
                pageTitle: '资产评估师'
            }
        },
        {
            name: 'asset_invoiceTip',
            path: '/asset/invoiceTip',
            component: asset_invoiceTip,
            meta: {
                requiresAuth: false,
                pageTitle: '资产评估师'
            }
        },
        {
            name: 'asset_download',
            path: '/asset/download',
            component: asset_download,
            meta: {
                requiresAuth: false,
                pageTitle: '资产评估师'
            }
        },

        {
            name: 'asset_textTip',
            path: '/asset/textTip',
            component: asset_textTip,
            meta: {
                requiresAuth: false,
                pageTitle: '资产评估师'
            }
        },
        {
            name: 'default_examReg_payBack',
            path: '/default/examReg/payBack',
            component: default_examReg_payBack,
            meta: {
                requiresAuth: false,
                pageTitle: '支付成功'
            }
        },
        {
            name: 'default_order_beikeReservation',
            path: '/default/order/beikeReservation',
            component: default_order_beikeReservation,
            meta: {
                requiresAuth: false,
                pageTitle: '贝壳预约'
            }
        },
        {
            name: 'default.printPage',
            path: '/default/printPage',
            component: default_printPage,
            meta: {
                requiresAuth: false,
                pageTitle: '打印'
            }
        },

        {
            name: 'default_register',
            path: '/default/register',
            component: default_register,
            meta: {
                requiresAuth: false,
                pageTitle: '注册'
            }
        },
        {
            name: 'default_moreAnnoucement',
            path: '/default/home/moreAnnoucement',
            component: default_moreAnnoucement,
            meta: {
                projectPage: true,
                pageTitle: '更多公告'
            }
        },
        // {
        //     name: 'default_registerStep1',
        //     path: '/default/registerStep1',
        //     component: default_registerStep1,
        //     meta: {
        //         requiresAuth: false,
        //         pageTitle: '注册'
        //     }
        // },
        {
            name: 'default_findPwd',
            path: '/default/findPwd',
            component: default_findPwd,
            meta: {
                requiresAuth: false,
                pageTitle: '找回密码'
            }
        },
        {
            name: 'default.notFound',
            path: '/default/notFound',
            component: default_notFound,
            meta: {
                requiresAuth: false,
                pageTitle: '404'
            }
        },
        {
            name: 'default.notFoundAll',
            path: '*',
            component: default_notFound,
            meta: {
                requiresAuth: false,
                pageTitle: '404'
            }
        },
        {
            name: 'default.dyIndex',
            path: '/default/dyIndex',
            component: default_dyIndex,
            meta: {
                requiresAuth: false,
                pageTitle: '首页'
            }
        },
        {
            name: 'default.noticePage',
            path: '/default/noticePage',
            component: default_noticePage,
            meta: {
                requiresAuth: false,
                pageTitle: '公告'
            }
        },
        {
            name: 'default.dynotice',
            path: '/default/dynotice',
            component: default_dynotice,
            meta: {
                requiresAuth: false,
                pageTitle: '公告详情'
            }
        },
        /*默认模板路由结束*/
    ]
})